const ShareIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <g clip-path='url(#clip0_74691_202)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M5.72319 9.45337L9.16465 6.01132C9.39187 5.7841 9.76124 5.7841 9.98846 6.01132C10.2157 6.23912 10.2157 6.60792 9.98846 6.83571L6.547 10.2772L9.24856 15.3802C9.46645 15.7921 9.90982 16.0345 10.3742 15.996C10.8391 15.9576 11.2364 15.6459 11.3838 15.2031C12.4092 12.1275 14.9808 4.41207 15.9404 1.53399C16.0796 1.11509 15.9707 0.65367 15.659 0.341392C15.3467 0.0291151 14.8853 -0.0798334 14.4664 0.0599923L0.796674 4.61656C0.354475 4.76396 0.0427756 5.16072 0.00374093 5.62564C-0.0347111 6.09056 0.207662 6.53334 0.620147 6.75182L5.72319 9.45337Z'
          fill='#8B5CF6'
        />
      </g>
      <defs>
        <clipPath id='clip0_74691_202'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ShareIcon;
